// PageDescription: 본인인증 화면
import EmptyLayout from '@/components/layouts/EmptyLayout';
import PhoneVerificationView from '@/views/phone-verification/ui/PhoneVerificationView';

const PhoneVerificationPage = () => {
  return <PhoneVerificationView />;
};

export default PhoneVerificationPage;

PhoneVerificationPage.Layout = EmptyLayout;
